import { combineReducers } from 'redux';
import instructors from './instructor.reducer';

const instructorAppReducer = combineReducers({
    instructors,
});

export default instructorAppReducer;


// WEBPACK FOOTER //
// src/main/content/instructor/store/reducers/index.js